const loadStyles = async () => {
    await import('./css/app.scss');
}

const loadApp = async () => {
    const appRoot = document.createElement('div');
    appRoot.id = 'root';
    document.body.appendChild(appRoot);

    const App = await import('./App').then((module) => module.default);
    const { createRoot } = await import('react-dom/client');
    const React = await import('react');

    const reactRoot = createRoot(appRoot);
    reactRoot.render(
        <React.StrictMode>
            <React.Suspense fallback={<React.Fragment />}>
                <App />
            </React.Suspense>
        </React.StrictMode>
    );
}

(async () => {
    try {
        await Promise.all([
            loadStyles(),
            loadApp(),
        ]);
    } catch (error) {
        console.error('Error loading the application:', error);

        const errorOverlay = document.createElement('div');
        errorOverlay.className = 'error-overlay';
        document.body.appendChild(errorOverlay);

        const errorMessage = document.createElement('div');
        errorMessage.className = 'error-message';
        errorMessage.textContent = 'Failed to load the application. Please try again later.';
        errorOverlay.appendChild(errorMessage);
    } finally {
        document.body.classList.remove('app-loading');
    }
})();
